export default {
  tabChatVis(state: any, tabChatVis: boolean) {
    state.tabChatVis = tabChatVis;
  },
};
